// Angular modules
import { Component }           from '@angular/core';

// Ionic modules
import { GoogleAnalytics }     from '@ionic-native/google-analytics';
import { NavController }       from 'ionic-angular';
import { ToastController }     from 'ionic-angular';
import { MenuController }      from 'ionic-angular';

// External modules
import { Product }             from '../../shared/models/product';
import { CartService }         from '../../shared/providers/cart-service';
import { Cart }                from '../../shared/providers/cart.provider';
import { CartItem }            from '../../shared/providers/cart.provider';
import { Cartable }            from '../../shared/providers/cart.provider';
import { ProductDetailPage }   from '../product-detail/product-detail';
import { TranslateService }    from '@ngx-translate/core';
import { Calculation, FlushingCalculation, VacuumCalculation } from '../calculator-results/calculation.provider';

@Component({
  selector    : 'page-cart',
  templateUrl : 'cart.html'
})
export class CartPage
{
  public  cart        : Cart        = new Cart();
  private visibleCalc : Set<string> = new Set<string>();

  constructor
  (
    public  navCtrl     : NavController,
    public  translate   : TranslateService,
    public  menuCtrl    : MenuController,
    public  toastCtrl   : ToastController,
    private cartService : CartService,
    private analytics   : GoogleAnalytics
  )
  {
    this.getCart();
  }

  isFlushingCalculation(calc : Calculation) : boolean
  {
    return calc instanceof FlushingCalculation;
  }

  isVacuumCalculation(calc : Calculation) : boolean
  {
    return calc instanceof VacuumCalculation;
  }

  asFlush(calc : Cartable) : FlushingCalculation
  {
    return <FlushingCalculation>calc;
  }

  asVacuum(calc : Cartable) : VacuumCalculation
  {
    return <VacuumCalculation>calc;
  }

  asCalculation(calc : Cartable) : Calculation
  {
    return <Calculation>calc;
  }

  asProduct(calc : Cartable) : Product
  {
    return <Product>calc;
  }

  toggleCalcVisibility(calc : Calculation)
  {
    if (this.isVisible(calc))
      return this.visibleCalc.delete(calc.getBusinessCode());
    this.visibleCalc.add(calc.getBusinessCode());
  }

  isVisible(calc : Calculation)
  {
    return this.visibleCalc.has(calc.getBusinessCode());
  }

  getCart()
  {
    this.cart = this.cartService.getCart()
  }

  sendMail(group : string)
  {
    this.cartService.sendEmail(group)
    .then(email => {this.presentToast(this.translate.instant('MAIL_SENT') + ' ' + email)})
    .catch(err => this.presentToast(err));
  }

  ionViewDidLoad() { this.analytics.trackView("cart"); }

  toggleMenu() { this.menuCtrl.toggle(); }

  backAction() { this.navCtrl.pop({animate: false}); }

  goTo(product : Product)
  {
    this.navCtrl.push(ProductDetailPage, product, {animate: false});
  }

  removeFromCart(cartItem : CartItem)
  {
    if (!window.confirm(this.translate.instant("CONFIRM_DELETE")))
      return;

    this.cartService.removeItem(cartItem)
    this.getCart();
  }

  presentToast(message)
  {
    let toast = this.toastCtrl.create(
    {
      message: message,
      duration: 3000
    });
    toast.present();
  }

}


// WEBPACK FOOTER //
// ./src/app/pages/cart/cart.ts